// Translations for Table-Tech application
export default {
  ar: {
    // General
    connected: "متصل",
    offline: "غير متصل",
    table: "طاولة",
    takeaway: "سفري",
    kitchen: "المطبخ",
    drinks: "المشروبات",
    desserts: "الحلويات",
    noOrders: "لا توجد طلبات",
    noTables: "لا توجد طاولات نشطة حالياً",
    orderDetails: "تفاصيل الطلب",
    clickToClose: "انقر في أي مكان خارج النافذة للإغلاق",
    notes: "ملاحظات",
    all: "الكل",
    active: "نشط",
    completed: "مكتمل",
    addedAt: "أضيف في",
    orderTimeline: "سجل الطلب",
    additions: "إضافات",
    itemAdded: "تمت إضافة عنصر",
    statusChanged: "تم تغيير الحالة",
    
    // Order related
    orderNumber: "رقم الطلب",
    viewDetails: "عرض التفاصيل",
    items: "صنف",
    startPreparation: "بدء التحضير",
    complete: "اكتمل التحضير",
    
    // Status related
    statusNew: "جديد",
    statusPreparing: "جاري التحضير",
    statusReady: "جاهز",
    statusCompleted: "مكتمل",
    statusCancelled: "ملغي",
    
    // Main interface
    newOrders: "طلبات جديدة",
    preparingOrders: "قيد التحضير",
    noNewOrders: "لا توجد طلبات جديدة حالياً",
    noPreparingOrders: "لا توجد طلبات قيد التحضير حالياً",
    noCompletedOrdersInArchive: "لا توجد طلبات مكتملة في الأرشيف",
    noCompletedOrdersToClear: "لا توجد طلبات مكتملة لمسحها من آخر 6 ساعات",
    
    // Cancel related
    cancelConfirmation: "هل أنت متأكد أنك تريد إلغاء هذا الطلب؟",
    confirm: "تأكيد",
    cancel: "إلغاء",
    cancelled: "تم الإلغاء",
    
    // Archive
    archive: "الأرشيف",
    localArchive: "محلي",
    cloudArchive: "سحابي",
    searchOrders: "البحث في الطلبات",
    noOrdersInArchive: "لا توجد طلبات في الأرشيف",
    more: "المزيد",
    totalOrders: "إجمالي الطلبات",
    storageUsed: "المساحة المستخدمة",
    orders: "طلبات"
  },
  de: {
    // General
    connected: "Verbunden",
    offline: "Offline",
    table: "Tisch",
    takeaway: "Zum Mitnehmen",
    kitchen: "Küche",
    drinks: "Getränke",
    desserts: "Desserts",
    noOrders: "Keine Bestellungen",
    noTables: "Keine aktiven Tische",
    orderDetails: "Bestelldetails",
    clickToClose: "Klicken Sie außerhalb des Fensters zum Schließen",
    notes: "Notizen",
    all: "Alle",
    active: "Aktiv",
    completed: "Abgeschlossen",
    addedAt: "Hinzugefügt um",
    orderTimeline: "Bestellverlauf",
    additions: "Ergänzungen",
    itemAdded: "Artikel hinzugefügt",
    statusChanged: "Status geändert",
    
    // Order related
    orderNumber: "Bestellnummer",
    viewDetails: "Details anzeigen",
    items: "Artikel",
    startPreparation: "Zubereitung starten",
    complete: "Zubereitung abgeschlossen",
    
    // Status related
    statusNew: "Neu",
    statusPreparing: "In Zubereitung",
    statusReady: "Fertig",
    statusCompleted: "Abgeschlossen",
    statusCancelled: "Storniert",
    
    // Main interface
    newOrders: "Neue Bestellungen",
    preparingOrders: "In Zubereitung",
    noNewOrders: "Derzeit keine neuen Bestellungen",
    noPreparingOrders: "Derzeit keine Bestellungen in Zubereitung",
    noCompletedOrdersInArchive: "Keine abgeschlossenen Bestellungen im Archiv",
    noCompletedOrdersToClear: "Keine abgeschlossenen Bestellungen aus den letzten 6 Stunden zu löschen",
    
    // Cancel related
    cancelConfirmation: "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    cancelled: "Storniert",
    
    // Archive
    archive: "Archiv",
    localArchive: "Lokal",
    cloudArchive: "Cloud",
    searchOrders: "Bestellungen suchen",
    noOrdersInArchive: "Keine Bestellungen im Archiv",
    more: "Weitere",
    totalOrders: "Gesamtbestellungen",
    storageUsed: "Verwendeter Speicher",
    orders: "Bestellungen"
  }
}